import z from 'zod';
import { PublicSchema } from '../settings/public-schema';
import { Base } from './owner-schema';
import { SubscriptionSchema } from '../finance/subscription-schema';

export const BusinessSchema = Base.extend({
  account_type: z.literal('business'),
  subscription: SubscriptionSchema.default({
    plan: 'SALON',
    isFounder: false,
    expiresAt: null,
    updatedAt: null,
  }),

  // --- STAFF: Gestión y Administración (Dueños y administradores del negocio) ---
  staff: z
    .array(
      z.object({
        uid: z.string(),
        email: z.string(),
        role: z.enum(['admin', 'manager']),
        status: z.enum(['active', 'inactive']).default('active'),
      }),
    )
    .default([]),

  public: PublicSchema,
});

export type Business = z.infer<typeof BusinessSchema>;
export type BusinessWithId = Business & { id: string };
export type BusinessCreate = Omit<Business, 'id'>;
